import React, { useState, useEffect } from 'react'
import Session from "react-session-api";

function Profile() {
    if (localStorage.getItem("loginsession") != null) {
        const result = JSON.parse(localStorage.getItem("loginsession"));
        var email = result.UserName;
        var name = result.FullName;
        var emailid = result.EmailID;
        var mob = result.MobileNumber;
    }
    

    //if (Session.get("loginsession") != null) {
    //    const result = Session.get("loginsession");
    //    var token = result.AccessToken;
    //    var uid = result.UserID;
    //    var email = result.UserName;
    //    var name = result.FullName;
    //    var emailid = result.EmailID;
    //    var mob = result.MobileNumber;
    //}
    
    return (
        <>
            <div className="alert alert-light d-flex align-items-center mb-3 px-4">
                <h5
                    className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                    style={{ fontSize: "14px" }}>
                    Home
                </h5>
                <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-danger"></span>
                <span className="text-danger font-weight-500 f13">Profile</span>
            </div>

            <div className="yoc-grid yoc-grid--desyocop yoc-grid--ver yoc-grid--ver-desyocop yoc-app">
                <div className="col-xl-12 col-lg-12 p-0">
                    <div className="yoc-portlet yoc-portlet--height-fluid">
                        <div className="yoc-portlet__body">
                            <div className="col-md-12">
                                <div className="gen-box" style={{ background: "none!important" }}>
                                    <div className="section-part ">
                                        <p><strong>Name:</strong> <span>{name}</span></p>
                                        <p><strong>EmailID:</strong> <span>{email}</span></p>
                                        <p><strong>UserName:</strong> <span>{emailid}</span></p>
                                        <p><strong>MobileNumber:</strong> <span>{mob}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Profile;
